// DS6.1.2
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import { ThemeOverride, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import s from './SelectionListCard.scss';
const SelectionListCard = (_param)=>{
    var { className , children , innerRef  } = _param, props = _object_without_properties(_param, [
        "className",
        "children",
        "innerRef"
    ]);
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.LIGHT,
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", _extends({
        className: s['content'],
        ref: innerRef
    }, props), children));
};
SelectionListCard.displayName = 'SelectionListCard';
export default SelectionListCard;
